import { render, staticRenderFns } from "./CommandeStatus.vue?vue&type=template&id=54d68e32"
import script from "./CommandeStatus.vue?vue&type=script&lang=js"
export * from "./CommandeStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports